module.exports = __webpack_public_path__ + "img/cdt_metalwarmint.f3e9eef.png";